export var IndexType;
(function (IndexType) {
    // eslint-disable-next-line
    IndexType[IndexType["Value"] = 0] = "Value";
    // eslint-disable-next-line
    IndexType[IndexType["FullText"] = 1] = "FullText";
    // eslint-disable-next-line
    IndexType[IndexType["Geo"] = 2] = "Geo";
})(IndexType || (IndexType = {}));
export class AbstractIndex {
}
//# sourceMappingURL=abstract-index.js.map